import { getAdvanced } from '../../../helpers/utils';

export default node => {
    return {
        content: node.innerHTML,
        ...getAdvanced(node)
    };
};
